export default __webpack_public_path__ + "static/media/942.ea7c3e62.gif";